// Google Consent Mode v2 helpers. The default denied state is initialised in
// public/index.html BEFORE any Google script loads. These helpers only update
// consent AFTER an explicit user interaction and persist the choice.

export const CONSENT_KEY = 'invelitio_consent_v1';

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function saveConsent(consent) {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (e) {
    /* ignore write errors (private mode) */
  }
}

export function clearConsent() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (e) {
    /* ignore */
  }
}

function gtagSafe() {
  if (typeof window === 'undefined') return () => {};
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === 'function') return window.gtag;
  return function () {
    window.dataLayer.push(arguments);
  };
}

// Reusable consent updater. analytics -> analytics_storage, marketing -> ad_* signals.
export function updateConsent({ analytics = false, marketing = false } = {}) {
  const gtag = gtagSafe();
  gtag('consent', 'update', {
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
    analytics_storage: analytics ? 'granted' : 'denied',
  });
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'cookie_consent_update' });
  }
}

// Re-apply a previously saved consent choice on subsequent visits.
export function applyStoredConsent() {
  const stored = getStoredConsent();
  if (stored && (stored.analytics !== undefined || stored.marketing !== undefined)) {
    updateConsent(stored);
    return stored;
  }
  return null;
}
